
import { StatusBlock } from '05-ui-kit';
import { defineComponent, useMeta } from '@nuxtjs/composition-api';
import { computed, ref } from '@vue/composition-api';
import SearchSemantic from '~/components/SearchSemantic/SearchSemantic.vue';
import DataEntityList from '~/data/DataEntityList/DataEntityList.vue';
import type Store from '~/type/Store';
import wrapFunc from '~/helper/wrapFunc';
import type SupportApi from '~/api/support.api';
import { useSocialStore } from '~/store/social';
type RequestType = Awaited<ReturnType<typeof SupportApi.getStores>>['result'];
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.setup = (__props, __ctx) => {
  useMeta(() => ({
    title: 'Контакты',
    meta: [{
      hid: 'description',
      name: 'description',
      content: 'Время работы магазина: 09:00 - 21:00, без перерыва и выходных. Контакты магазина 05.ru'
    }]
  }));
  const value = ref<Store>();
  const storeList = ref<RequestType>([]);
  const bound = ref<string[][]>();
  const zoom = 6;
  const socialStore = useSocialStore();
  const getMapCenter = computed(() => {
    if (value.value?.lat && value.value?.lon) return [value.value.lat, value.value.lon];else return undefined;
  });
  const formatPhone = computed<string>(() => {
    return socialStore.social.phone.replace(/\s|-|[()]/g, '');
  });
  function onSuccess({
    response
  }: {
    response: RequestType;
  }) {
    storeList.value = response;
    bound.value = getBounds(response);
  }
  function getBounds(list: RequestType) {
    const boundsArr = [];
    const minGpsN = list.reduce((lowest, item) => item.lat < lowest.lat ? item : lowest);
    const maxGpsN = list.reduce((lowest, item) => item.lat > lowest.lat ? item : lowest);
    const minGpsS = list.reduce((lowest, item) => item.lon < lowest.lon ? item : lowest);
    const maxGpsS = list.reduce((lowest, item) => item.lon > lowest.lon ? item : lowest);
    boundsArr[0] = [minGpsN.lat + 1, minGpsS.lon];
    boundsArr[1] = [maxGpsN.lat, maxGpsS.lon];
    return boundsArr;
  }
  function onStoreClick(data: Store) {
    value.value = data;
  }
  function getDepartments(response: RequestType) {
    return response.map(el => {
      return {
        '@type': 'Organization',
        'name': el.title,
        'image': 'https://05.ru/images/logo-80px.svg',
        'telephone': el.phone,
        'location': {
          address: {
            '@type': 'PostalAddress',
            'streetAddress': el.address,
            'addressLocality': el.city,
            'postalCode': '367000',
            'addressCountry': 'RU'
          },
          geo: {
            '@type': 'GeoCoordinates',
            'latitude': el.lat,
            'longitude': el.lon
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            'opens': el.scheduleAdvanced.from,
            'closes': el.scheduleAdvanced.to
          }
        }
      };
    });
  }
  function createSearchSemanticObj(response: RequestType) {
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': '05.ru',
      'image': 'https://05.ru/images/logo-80px.svg',
      '@id': 'https://05.ru',
      'url': 'https://05.ru',
      'sameAs': [...Object.values(socialStore.social)],
      'department': [...getDepartments(response)]
    };
  }
  return {
    wrapFunc,
    value,
    storeList,
    bound,
    zoom,
    socialStore,
    getMapCenter,
    formatPhone,
    onSuccess,
    onStoreClick,
    createSearchSemanticObj
  };
};
__sfc_main.components = Object.assign({
  DataEntityList,
  StatusBlock,
  SearchSemantic
}, __sfc_main.components);
export default __sfc_main;
